import React from "react";
import { SearchItem } from "./SearchItem";
import Pagination from "../Paging/Pagination";
import { useState, useEffect } from "react";
import severUrl from "../../api";
import sortup from "../../assets/images/sortcom.png";
import sortdown from "../../assets/images/sortcomdown.png";
import { useSelector, useDispatch } from "react-redux";
import { connect } from 'react-redux';
import { addTodo, listTodo, listPost, addPostList } from '../../redux/_actions/post.action';
import axios from "axios";
import { DummyItem } from "./DummyItem";

const options = { //Typescript ways of adding the type
  year: "numeric",
  month: "long",
};

// class SearchList extends React.Component {
//   state = {
//     posts: [
//       { title: 'post 1', id: 1 },
//       { title: 'post 3', id: 3 },
//       { title: 'post2', id: 2 },
//       { title: 'post5', id: 5 },
//     ],
//     tags: [],
//     currentPage: 0,
//     totalPages: 0,
//     presences: [],
//     desc: false,
//     sortState: false,
//     loaded: false,
//   };

//   componentDidMount() {

//     var bodyFormData = new FormData();
//     bodyFormData.append("currentPage", 1);
//     bodyFormData.append("numberPerPage", 10);

//     try {
//       // const data = await fetchData('https://api.example.com/data');
//       // this.setState({ data, loading: false });
//       axios.post(severUrl + "blog/list/current/", bodyFormData).then((response) => response.data)
//         .then((data) => {
//           this.setState({posts: data.data});
//           console.log(data.data)
//           this.setState({ loaded: true })
//           this.setState({ currentPage: 0 });
  
//         })

//     } catch (error) {
//       //this.setState({ error, loading: false });
//     }


//     const choice = this.state.posts.slice(0, 3);
//     this.setState({ presences: [...choice] });
//     console.log(this.state.presences)

//   }

//   onSort = (desc) => {
//     if (this.state.desc) {
//       this.state.posts.sort(function (a, b) {
//         return new Date(a.created_on) - new Date(b.created_on)
//       });
//     } else {
//       this.state.posts.sort(function (a, b) {
//         return new Date(b.created_on) - new Date(a.created_on)
//       });
//     }
//     this.setState({ post: [...this.state.posts] });
//     this.setState({ desc: !this.state.desc });
//   };

//   render() {
//     return (
//       <>
//       <div style={{marginTop:"100px"}}>
//         <button onClick={() => this.onSort()}>Sort</button>
//         <ul>
//           {this.state.posts &&
//             Array.from(this.state.presences).map((pst, index) => {
//               return <li>{pst.post_id}</li>;
//             })}
//         </ul>
//         </div>
//       </>
//     );
//   }
// }

// export default SearchList;

class SearchList extends React.Component {

  state = {
    posts: [],
    tags: [],
    currentPage: 0,
    totalPages: 0,
    presences: [],
    desc: true,
    sortState: false,
    loaded: false
  };

  componentDidMount() {

    var bodyFormData = new FormData();
    bodyFormData.append("currentPage", 1);
    bodyFormData.append("numberPerPage", 10);

    try {
      // const data = await fetchData('https://api.example.com/data');
      // this.setState({ data, loading: false });
      axios.post(severUrl + "blog/list/current/", bodyFormData).then((response) => response.data)
        .then((data) => {
          this.setState({ totalPages: Math.ceil(data.count / 10) });
          // this.props.addPostList(data.data);
          this.setState({posts: data.data})
          // !!!!!!!!!!! IMPORTANT
          this.setState({presences: data.data.slice(0, 10)})
          this.setState({ currentPage: 0 });
          this.setState({ loaded: true })
        }).catch(function(error) {
          console.log('request failed', error)
    })

    } catch (error) {
      //this.setState({ error, loading: false });
          console.log('request failed', error)
    }
  }

  onPageNumberChange = (value) => {
    var N = 10;
    this.setState({ currentPage: value });
    // var choice = this.props.todoState.list.slice(N * value, N * value + N);
    var choice = this.state.posts.slice(N * value, N * value + N);
    this.setState({ presences: [...choice] });
    // this.props.listPost(value, 10);
  };

  onSort = () => {
    const sortByName = [...this.state.posts];

    if (this.state.desc) {

      sortByName.sort((a, b) => {
        return new Date(a.created_on) - new Date(b.created_on)
      })

    } else {

      sortByName.sort((a, b) => {
        return new Date(b.created_on) - new Date(a.created_on)
      })}

    console.log(sortByName)

    var N = 10;
    var choice = sortByName.slice(N * this.state.currentPage, N * this.state.currentPage + N);
    this.setState({ presences: [...choice] })

    this.setState({posts: [...sortByName]});

    this.setState({ desc: !this.state.desc })
    this.setState({ sortState: !this.state.sortState })

    this.forceUpdate();

  }

  // mapTag = (rel) => {
  //   const ts = []
  //   for (let i = 0; i < rel.length; i++) {
  //     for (let j = 0; j < this.state.tags.length; j++) {
  //       if (this.state.tags[j].id == rel[i].tag) {
  //         ts.push(this.state.tags[j].title);
  //       }
  //     }
  //   }
  //   return ts;
  // }

  // saveTodo = () => {
  //   this.props.addTodo({ id: 4, title: "2233" });
  // };



  render() {

    // if (!this.state.loaded) {
    //   return (
    //     <><div style={{ filter: 'blur(8px)', display:this.state.loaded ? "none" : "block" }}>
    //       <DummyItem />
    //       <DummyItem />
    //       <DummyItem /></div></>
    //   )
    // }
    
    return (
      <>
      <div style={{ filter: 'blur(8px)', display:this.state.loaded ? "none" : "block" }}>
          <DummyItem />
          <DummyItem />
          <DummyItem />
      </div>
        <div className="search-list">
          <div style={{ alignContent: "center", textAlign: "center", alignItems: "center", width: "100%", marginTop: "2em" }}>
            <Pagination
              className="pagination"
              currentPage={this.state.currentPage}
              totalPages={this.state.totalPages}
              onChangePage={this.onPageNumberChange}
            />
            <div className="container mobile" style={{ alignContent: "left", textAlign: "left", alignItems: "center", width: "100%", paddingLeft: "0" }}>
              <button onClick={this.onSort}><img style={{ maxWidth: "20px" }} src={this.state.sortState ? sortup : sortdown} /></button>
            </div>
          </div>
          <ul>
            {this.props.todoState.list &&
              Array.from(this.state.presences).map((pst, index) => {
                return (
                  <SearchItem
                    data={{
                      thumnail: pst.ava,
                      title: pst.post_title,
                      description: pst.post_abstract,
                      tag: pst.tags,
                      slug: pst.slug,
                      ava: null,
                      created: new Date(pst.created_on).toLocaleDateString([], options),
                      mavail: null,
                      currVer: pst.ver,
                      authors: pst.authors,
                      total_visited: pst.total_visited,
                    }}
                  />)
              }
              )
            }
          </ul>
          <div style={{ alignContent: "center", textAlign: "center", alignItems: "center", width: "100%" }}>
            <Pagination
              className="pagination"
              currentPage={this.state.currentPage}
              totalPages={this.state.totalPages}
              onChangePage={this.onPageNumberChange}
            />
          </div>
        </div>
      </>
    );
  }
}


function mapStateToProps(state) {
  return {
    todoState: state.todo,
  };
}


export default connect(mapStateToProps, { addTodo, listTodo, listPost, addPostList })(SearchList);


